import { DeleteOutlined, EditOutlined, PlusOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { gql, useMutation } from "@apollo/client";
import { ActivityStagesQueryProvider } from "__legacy/queries/activities/ActivityStagesQueryProvider";
import { Button, Input, Layout, notification, PageHeader, Popconfirm, Row, Space, Table, Tabs, Tooltip } from "antd";
import { Fragment, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

const deleteActivityStageMutation = gql`
  mutation($id: ID!) {
    deleteActivityStage(id: $id) {
      activityStage {
        id
        name
      }
    }
  }
`;

export const List: React.FC<{}> = () => {
  const navigate = useNavigate();
  const [activePane, setActivePane] = useState();

  const [searchQuery, setSearchQuery] = useState<string | null>(null);
  const handleSearch = (value: string) => setSearchQuery(value.trim());

  const [execDelete] = useMutation(deleteActivityStageMutation, {
    errorPolicy: "none",
    onError: (error) => {
      notification.error({
        message: error.message,
      });
    },
    onCompleted: ({ deleteActivityStage: { activityStage } }) => {
      notification.success({
        message: `Stage "${activityStage.name}" deleted`,
      });
    },
    refetchQueries: ["ActivityStagesQuery"],
  });

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (value: string, resource: any) => <NavLink to={`${resource.id}/edit`}>{value}</NavLink>,
    },
    {
      title: "Certification Kind",
      dataIndex: "kind",
    },
    {
      title: "Description",
      dataIndex: "description",
    },
    {
      width: "80px",
      title: "Actions",
      dataIndex: "id",
      render: (id: string) => (
        <Row justify="end">
          <Space>
            <Tooltip title="Edit" placement="bottom">
              <Button onClick={() => navigate(`${id}/edit`)} icon={<EditOutlined />}></Button>
            </Tooltip>
            <Popconfirm
              title="Are you sure?"
              icon={<QuestionCircleOutlined />}
              onConfirm={() => execDelete({ variables: { id } })}
            >
              <Tooltip title="Delete" placement="bottom">
                <Button danger icon={<DeleteOutlined />}></Button>
              </Tooltip>
            </Popconfirm>
          </Space>
        </Row>
      ),
    },
  ];

  return (
    <ActivityStagesQueryProvider variables={{ kind: activePane, search: searchQuery }}>
      {({ activityStages }) => (
        <Fragment>
          <PageHeader
            ghost={true}
            title="Stages"
            extra={
              <Fragment>
                <Input.Search
                  allowClear
                  placeholder="search"
                  onSearch={handleSearch}
                  defaultValue={searchQuery ?? ""}
                  style={{ width: 500 }}
                />
                <Button onClick={() => navigate("new")} type="primary">
                  <PlusOutlined />
                  New
                </Button>
              </Fragment>
            }
            footer={
              <Tabs
                activeKey={activePane}
                onChange={(activeKey: any) => setActivePane(activeKey !== "all" ? activeKey : undefined)}
              >
                <Tabs.TabPane tab="All" key="all" />
                <Tabs.TabPane tab="Company" key="company" />
                <Tabs.TabPane tab="Product" key="product" />
                <Tabs.TabPane tab="Skill" key="skill" />
              </Tabs>
            }
          />
          <Layout.Content className="content">
            <Table rowKey="id" columns={columns} dataSource={activityStages} pagination={false} />
          </Layout.Content>
        </Fragment>
      )}
    </ActivityStagesQueryProvider>
  );
};
